module.exports.app_id = "Feed+ Premium";

module.exports.api_url = "https://premium-api.polymedia.nl";
module.exports.api_token = "ZG99id7u4U9LE05n";

if(window.location.href.startsWith("http://localhost:3000/")) {
	module.exports.api_url = "http://192.168.0.10:3001";
	module.exports.api_token = "123";
}



// WEBPACK FOOTER //
// ./src/config.js